<div [class.hidden]="!show">
  @if (show) {
    <div class="loading"></div>
  }
</div>